import React from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LineChartPictreePhotoShoot from "components/Charts/LineChartPictreePhotoShoot";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 2,
  },
}));

const defaultLegendMap = {
  countRegularSeason: "レギュラーS",
  countBoost1: "ブースト 1",
  countBoost2: "ブースト 2",
};

const BudgetRemainingTrendChart = ({ trend, legend, chartConfig, colorValue }) => {
  const classes = useStyles();
  const legendMap = chartConfig && Object.keys(chartConfig).length > 0 ? chartConfig : defaultLegendMap;
  const chartLegend = Array.isArray(legend) ? legend : Object.values(legendMap);
  const chartColors = Array.isArray(colorValue) && colorValue.length > 0 ? colorValue : ["#3F7ECC", "#E4961A", "#D45F2D"];

  return (
    <Card>
      <CardContent>
        <Typography className={classes.title}>残予算推移（原資別）</Typography>
        <LineChartPictreePhotoShoot
          legend={chartLegend}
          lblSaveImage=""
          xAisData={Array.isArray(trend?.date) ? trend.date : []}
          seriesData={[trend || {}]}
          chartType="line"
          chartConfig={legendMap}
          yAxis={[
            {
              type: "value",
              name: "残予算（百万円）",
              alignTicks: true,
              axisLine: { show: true },
              axisLabel: { formatter: "{value}M" },
            },
          ]}
          colorValue={chartColors}
        />
      </CardContent>
    </Card>
  );
};

export default BudgetRemainingTrendChart;
